export default __webpack_public_path__ + "static/media/pages2_thumb.36ba89d8.jpg";